module.exports = __webpack_public_path__ + "static/media/patterns-detail.8f7e785a.svg";